import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { devtools as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { useShallow as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/shallow.mjs";
//#region src/lib/stores/geolocated-spaces-store/useGeolocatedSpacesStore.ts
var i = /* @__PURE__ */ function(e) {
	return e.DISTANCE_CLOSEST = "distance_closest", e.DISTANCE_FARTHEST = "distance_farthest", e.A_Z = "a_z", e.Z_A = "z_a", e;
}({}), a = {
	latitude: 0,
	longitude: 0,
	radius: 5e4
}, o = (e, t) => e.sort((e, n) => e.distanceFromUser !== void 0 && n.distanceFromUser !== void 0 ? t ? e.distanceFromUser - n.distanceFromUser : n.distanceFromUser - e.distanceFromUser : 0), s = (e, t) => e.sort((e, n) => {
	let r = e.space.name, i = n.space.name;
	return t ? r.localeCompare(i, void 0, { sensitivity: "base" }) : i.localeCompare(r, void 0, { sensitivity: "base" });
}), c = t(n((e, t) => ({
	geolocatedSpaces: [],
	filter: a,
	searchedSpaceTerm: "",
	sortValue: "a_z",
	isSearchingSpaceTerm: !1,
	clear: () => {
		e({
			searchedSpaceTerm: "",
			geolocatedSpaces: [],
			sortValue: "a_z",
			filter: a
		});
	},
	setSearchedSpaceTerm: (t = "") => e({ searchedSpaceTerm: t }),
	setGeolocatedSpaces: (n) => {
		let { sortValue: r } = t(), i = [];
		switch (r) {
			case "a_z":
				i = s(n, !0);
				break;
			case "z_a":
				i = s(n, !1);
				break;
			case "distance_closest":
				i = o(n, !0);
				break;
			case "distance_farthest":
				i = o(n, !1);
				break;
		}
		e({ geolocatedSpaces: i });
	},
	setSortValue: (n) => {
		let { geolocatedSpaces: r } = t();
		e({ sortValue: n }), t().setGeolocatedSpaces(r);
	},
	setFilter: (t) => {
		t && e({ filter: t });
	}
}))), l = (t) => e(c, r(t));
//#endregion
export { i as GeolocatedSpacesSortValues, c as geolocatedSpacesStore, l as useGeolocatedSpacesStore };
